import { render, staticRenderFns } from "./advertisingPoliciesList.vue?vue&type=template&id=1d82bcfa&scoped=true&"
import script from "./advertisingPoliciesList.vue?vue&type=script&lang=js&"
export * from "./advertisingPoliciesList.vue?vue&type=script&lang=js&"
import style0 from "./advertisingPoliciesList.vue?vue&type=style&index=0&id=1d82bcfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82bcfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VDatePicker,VIcon,VMenu,VSelect,VTextField})
